import React from 'react'
import PropTypes from 'prop-types'

import Box from '../styled/Box'
import FlexGrid from '../styled/FlexGrid'

function Project(props = {}) {
  return (
    <FlexGrid
      alignItems="center"
      display={{ _: 'block', md: 'flex' }}
      gutter="l"
    >
      <FlexGrid.Item mb={{ _: 'l', md: '0' }}>
        <Box as="a" href={props.link}>
          <Box
            as="img"
            src={props.image}
            size="200px"
            borderRadius="base"
            mx={{ _: 'auto', md: '0' }}
          />
        </Box>
      </FlexGrid.Item>
      <FlexGrid.Item flex="1">
        <Box as="h2">
          <Box as="a" href={props.link}>
            {props.title}
          </Box>
        </Box>
        <Box fontSize="s" mr={{ _: '0', lg: 'xl' }}>
          {props.children}
        </Box>
      </FlexGrid.Item>
    </FlexGrid>
  )
}

Project.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  image: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
}

export default Project
